module.exports = __webpack_public_path__ + "img/body-wrinkles.0bf2f397.svg";